import Decimal from 'decimal.js';

import { ConvertedPriceParams } from '../common/contracts';
import { PricingMeta } from 'components/Pricing/Pricing.types';
import { isPriceLocalized } from './isPriceLocalized';
import AcTooltip from 'components/AcTooltip/AcTooltip';
import { Tooltip } from '@mui/material';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

export const getConvertedPrice = (
  params: ConvertedPriceParams,
  pricePoints: PricingMeta[]
) => {
  return (
    <>
      {params.row.productsSequence.map(
        ({ priceInUsdCents }: { priceInUsdCents: number }, index) => {
          if (priceInUsdCents === 0) {
            return <span key={index}>Free</span>;
          } else {
            const price = new Decimal(priceInUsdCents)
              .dividedBy(100)
              .toFixed(2);
            return (
              <div
                className="flex items-center justify-between"
                style={{ minWidth: '90px' }}
              >
                <span key={index}>{`$${price}`}</span>
                {isPriceLocalized(priceInUsdCents, pricePoints) ? (
                  ''
                ) : (
                  <Tooltip
                    arrow
                    style={{ marginLeft: '2px', height: '16px' }}
                    title={
                      <AcTooltip content={'Price point is not localized'} />
                    }
                  >
                    <ErrorOutlineOutlinedIcon sx={{ color: '#A8A9B2' }} />
                  </Tooltip>
                )}
              </div>
            );
          }
        }
      )}
    </>
  );
};
